(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shaden-bottom-nav"] && !Shopify.designMode) return;
  try {
    window.shadenOpenCart = function() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    window.location.href = '{{ routes.cart_url }}';
  };

  window.shadenOpenSearch = function() {
    var modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') { modal.showDialog(); return; }
    window.location.href = '{{ routes.search_url }}';
  };

  document.addEventListener('cart:update', function(e) {
    var count = e.detail && e.detail.data && e.detail.data.itemCount;
    if (count === undefined && e.detail && e.detail.resource) count = e.detail.resource.item_count;
    if (count === undefined) return;
    var badge = document.querySelector('.sh-bnav__badge');
    var wrap = document.querySelector('.sh-bnav__cart-wrap');
    if (count > 0 && wrap) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'sh-bnav__badge';
        wrap.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shaden-card-2"] && !Shopify.designMode) return;
  try {
    function shadAddToCart2(variantId, btn) {
    btn.disabled = true;
    btn.classList.add('loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => fetch('/cart.js'))
    .then(r => r.json())
    .then(cart => {
      btn.classList.remove('loading');
      btn.classList.add('added');
      setTimeout(() => {
        btn.disabled = false;
        btn.classList.remove('added');
      }, 900);
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, data: { itemCount: cart.item_count } }
      }));
    })
    .catch(() => {
      btn.disabled = false;
      btn.classList.remove('loading');
    });
  }
  window.shadAddToCart2 = shadAddToCart2;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shaden-card-3"] && !Shopify.designMode) return;
  try {
    function shadC3Wish(btn) {
    btn.classList.toggle('on');
    var on = btn.classList.contains('on');
    var path = btn.querySelector('svg path');
    if (path) path.setAttribute('fill', on ? 'currentColor' : 'none');
    document.dispatchEvent(new CustomEvent('shaden:wishlist', { detail: { on: on } }));
  }

  function shadC3AddToCart(variantId, btn) {
    btn.disabled = true;
    btn.classList.add('added');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return fetch('/cart.js'); })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      btn.disabled = false;
      btn.classList.remove('added');
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, data: { itemCount: cart.item_count } }
      }));
    })
    .catch(function() {
      btn.disabled = false;
      btn.classList.remove('added');
    });
  }
  window.shadC3Wish = shadC3Wish;
  window.shadC3AddToCart = shadC3AddToCart;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shaden-lang-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-sh-lang-trigger]').forEach(function (btn) {
    var wrapper = btn.closest('.sh-lang');
    var dropdown = wrapper.querySelector('[data-sh-lang-dropdown]');

    /* Toggle on button click */
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = wrapper.hasAttribute('data-open');
      /* Close all others first */
      document.querySelectorAll('.sh-lang[data-open]').forEach(function (el) {
        el.removeAttribute('data-open');
        el.querySelector('[data-sh-lang-trigger]').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        wrapper.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    /* Close on outside click */
    document.addEventListener('click', function () {
      wrapper.removeAttribute('data-open');
      btn.setAttribute('aria-expanded', 'false');
    });

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        wrapper.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shaden-product-card"] && !Shopify.designMode) return;
  try {
    function shadAddToCart(variantId, btn) {
    btn.disabled = true;
    btn.style.background = 'var(--sh-wood)';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => fetch('/cart.js'))
    .then(r => r.json())
    .then(cart => {
      btn.disabled = false;
      btn.style.background = '';
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, data: { itemCount: cart.item_count } }
      }));
    })
    .catch(() => { btn.disabled = false; btn.style.background = ''; });
  }
  window.shadAddToCart = shadAddToCart;
  } catch(e) { console.error(e); }
})();

})();
